<template>
    <rkm-modal
        :title="item ? `Dente - ${item.numero}` : null"
        extra-large
        ref="RkmModal"
    >
        <rkm-form v-if="model">
            <rkm-area
                no-margin-top
                title="Problemas/condições"
            >
                <rkm-row>
                    <rkm-col cols="12">
                        <rkm-form-checkbox-group
                            :disabled="disabledProblemasCondicoesDenteInferior || disabledProblemasCondicoesDenteSuperior"
                            name="Problemas/condições"
                            v-model="model.problemasCondicoes"
                        >
                            <rkm-row>
                                <rkm-col
                                    v-for="problemaCondicao in problemasCondicoesParte1"
                                    :key="problemaCondicao.id"
                                    cols="4"
                                >
                                    <rkm-form-checkbox
                                        :value="problemaCondicao.id"
                                        v-bind="handleProblemaCondicaoProps(problemaCondicao.id)"
                                    >
                                        {{problemaCondicao.nome}}
                                    </rkm-form-checkbox>
                                </rkm-col>
                            </rkm-row>

                            <hr />

                            <rkm-row>
                                <rkm-col
                                    v-for="problemaCondicao in problemasCondicoesParte2"
                                    :key="problemaCondicao.id"
                                    cols="4"
                                >
                                    <rkm-form-checkbox
                                        :value="problemaCondicao.id"
                                        v-bind="handleProblemaCondicaoProps(problemaCondicao.id)"
                                    >
                                        {{problemaCondicao.nome}}
                                    </rkm-form-checkbox>
                                </rkm-col>
                            </rkm-row>
                        </rkm-form-checkbox-group>
                    </rkm-col>
                </rkm-row>
            </rkm-area>

            <rkm-row>
                <rkm-col cols="12">
                    <rkm-form-checkbox-group
                        :disabled="model.problemasCondicoes.length === 0"
                        :options="dentes.filter(dente => dente.problemasCondicoes.length === 0)"
                        label="Replicar problemas/condições para outros dentes"
                        text-field="nome"
                        v-model="model.replicarProblemasCondicoesOutrosDentes"
                        value-field="id"
                    />
                </rkm-col>
            </rkm-row>

            <BoxProcedimento :data="{additionals: data.additionals, model: model}" />

            <rkm-row class="mt-3">
                <rkm-col cols="12">
                    <rkm-form-checkbox-group
                        :disabled="model.procedimentos.length === 0"
                        :options="dentes"
                        label="Replicar procedimentos para outros dentes"
                        text-field="nome"
                        v-model="model.replicarProcedimentosOutrosDentes"
                        value-field="id"
                    />
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col cols="12">
                    <rkm-form-textarea
                        :validations="validations.observacao"
                        label="Observações dos procedimentos"
                        rows="6"
                        v-model="model.observacao"
                    />
                </rkm-col>
            </rkm-row>
        </rkm-form>

        <template v-slot:footer="{cancel}">
            <rkm-button @click="cancel">
                Fechar
            </rkm-button>

            <rkm-button
                @click="save"
                color="primary"
            >
                Salvar
            </rkm-button>
        </template>
    </rkm-modal>
</template>

<script>
// Components.
import BoxProcedimento from '@/components/ambulatorio/atendimento/components/soap/components/plano/components/odontograma/components/procedimento/Index'

// Enums.
import saudeBucalDenteProblemaCondicao from '@/enums/ambulatorio/saudeBucalDenteProblemaCondicao'

// Mixins.
import {object} from '@/mixins'

export default {
    components: {BoxProcedimento},
    computed: {
        disabledProblemasCondicoesDenteInferior() {
            return this.data.model.saudeBucal.odontograma.protesesTotais.includes('inferior') &&
                (this.getDentesInferioresDeciduos().some(dente => dente.id === this.model.id) || this.getDentesInferioresPermanentes().some(dente => dente.id === this.model.id))
        },
        disabledProblemasCondicoesDenteSuperior() {
            return this.data.model.saudeBucal.odontograma.protesesTotais.includes('superior') &&
                (this.getDentesSuperioresDeciduos().some(dente => dente.id === this.model.id) || this.getDentesSuperioresPermanentes().some(dente => dente.id === this.model.id))
        },
        problemasCondicoesParte1() {
            return this.getProblemasCondicoes().filter(problemaCondicao => this.getProblemasCondicoesParte1().includes(problemaCondicao.id))
        },
        problemasCondicoesParte2() {
            return this.getProblemasCondicoes().filter(problemaCondicao => this.getProblemasCondicoesParte2().includes(problemaCondicao.id))
        },
        dentes() {
            return this.getDentes()
        },
        validations() {
            return {
                observacao: {max: 5000},
            }
        },
    },
    data: () => ({
        enums: {saudeBucalDenteProblemaCondicao},
        item: null,
        model: null,
    }),
    methods: {
        open(item) {
            this.item = item

            this.edit()

            this.$refs.RkmModal.show()
        },
        edit() {
            this.resetForm()

            this.model = Object.assign(this.clone(this.item), {
                replicarProblemasCondicoesOutrosDentes: [],
                replicarProcedimentosOutrosDentes: [],
            })
        },
        update() {
            if (this.model.problemasCondicoes.some(problemaCondicao => this.getProblemasCondicoesToDisable().includes(problemaCondicao))) {
                this.model.fragmentos = this.getIsTratadoNull()
            }

            this.includeProblemasCondicoesOutrosDentes()
            this.includeProcedimentosOutrosDentes()

            Object.assign(this.item, this.model)
        },
        getIsTratadoNull() {
            return {
                centro: {isTratado: null},
                cima: {isTratado: null},
                baixo: {isTratado: null},
                direita: {isTratado: null},
                esquerda: {isTratado: null},
            }
        },
        includeProblemasCondicoesOutrosDentes() {
            this.model.replicarProblemasCondicoesOutrosDentes.forEach(replicarProblemaCondicaoOutroDente => {
                const denteInferiorDeciduo = this.getArcadas().inferior.dentes.deciduos.find(dente => dente.id === replicarProblemaCondicaoOutroDente)
                const denteInferiorPermanente = this.getArcadas().inferior.dentes.permanentes.find(dente => dente.id === replicarProblemaCondicaoOutroDente)
                const denteSuperiorDeciduo = this.getArcadas().superior.dentes.deciduos.find(dente => dente.id === replicarProblemaCondicaoOutroDente)
                const denteSuperiorPermanente = this.getArcadas().superior.dentes.permanentes.find(dente => dente.id === replicarProblemaCondicaoOutroDente)

                if (this.model.problemasCondicoes.some(problemaCondicao => this.getProblemasCondicoesToDisable().includes(problemaCondicao))) {
                    if (denteInferiorDeciduo) {
                        denteInferiorDeciduo.fragmentos = this.getIsTratadoNull()
                    }
                    else if (denteInferiorPermanente) {
                        denteInferiorPermanente.fragmentos = this.getIsTratadoNull()
                    }
                    else if (denteSuperiorDeciduo) {
                        denteSuperiorDeciduo.fragmentos = this.getIsTratadoNull()
                    }
                    else if (denteSuperiorPermanente) {
                        denteSuperiorPermanente.fragmentos = this.getIsTratadoNull()
                    }
                }

                this.model.problemasCondicoes.forEach(problemaCondicao => {
                    if (denteSuperiorPermanente && this.getProblemasCondicoesByDenteNumero(denteSuperiorPermanente.numero).some(p => p.id === problemaCondicao)) {
                        denteSuperiorPermanente.problemasCondicoes.push(problemaCondicao)
                    }
                    else if (denteSuperiorDeciduo && this.getProblemasCondicoesByDenteNumero(denteSuperiorDeciduo.numero).some(p => p.id === problemaCondicao)) {
                        denteSuperiorDeciduo.problemasCondicoes.push(problemaCondicao)
                    }
                    else if (denteInferiorDeciduo && this.getProblemasCondicoesByDenteNumero(denteInferiorDeciduo.numero).some(p => p.id === problemaCondicao)) {
                        denteInferiorDeciduo.problemasCondicoes.push(problemaCondicao)
                    }
                    else if (denteInferiorPermanente && this.getProblemasCondicoesByDenteNumero(denteInferiorPermanente.numero).some(p => p.id === problemaCondicao)) {
                        denteInferiorPermanente.problemasCondicoes.push(problemaCondicao)
                    }
                })
            })
        },
        includeProcedimentosOutrosDentes() {
            this.model.replicarProcedimentosOutrosDentes.forEach(replicarProcedimentoOutroDente => {
                const denteInferiorPermanente = this.getArcadas().inferior.dentes.permanentes.find(dente => dente.id === replicarProcedimentoOutroDente)
                const denteInferiorDeciduo = this.getArcadas().inferior.dentes.deciduos.find(dente => dente.id === replicarProcedimentoOutroDente)
                const denteSuperiorDeciduo = this.getArcadas().superior.dentes.deciduos.find(dente => dente.id === replicarProcedimentoOutroDente)
                const denteSuperiorPermanente = this.getArcadas().superior.dentes.permanentes.find(dente => dente.id === replicarProcedimentoOutroDente)

                this.model.procedimentos.forEach(procedimento => {
                    if (denteInferiorPermanente) {
                        const hasProcedimento = denteInferiorPermanente.procedimentos.find(p => p.procedimento.id === procedimento.procedimento.id)

                        if (!hasProcedimento) {
                            denteInferiorPermanente.procedimentos.push(procedimento)
                        }
                    }
                    else if (denteInferiorDeciduo) {
                        const hasProcedimento = denteInferiorDeciduo.procedimentos.find(p => p.procedimento.id === procedimento.procedimento.id)

                        if (!hasProcedimento) {
                            denteInferiorDeciduo.procedimentos.push(procedimento)
                        }
                    }

                    else if (denteSuperiorDeciduo) {
                        const hasProcedimento = denteSuperiorDeciduo.procedimentos.find(p => p.procedimento.id === procedimento.procedimento.id)

                        if (!hasProcedimento) {
                            denteSuperiorDeciduo.procedimentos.push(procedimento)
                        }
                    }
                    else if (denteSuperiorPermanente) {
                        const hasProcedimento = denteSuperiorPermanente.procedimentos.find(p => p.procedimento.id === procedimento.procedimento.id)

                        if (!hasProcedimento) {
                            denteSuperiorPermanente.procedimentos.push(procedimento)
                        }
                    }
                })
            })
        },
        save() {
            this.update()

            this.$refs.RkmModal.hide()
        },
        resetForm() {
            this.model = null
        },
        handleProblemaCondicaoProps(id) {
            const props = {}

            const parte1 = [
                this.enums.saudeBucalDenteProblemaCondicao.AUSENTE_A,
                this.enums.saudeBucalDenteProblemaCondicao.EXTRAIDO_E,
                this.enums.saudeBucalDenteProblemaCondicao.HIGIDO_H,
                this.enums.saudeBucalDenteProblemaCondicao.HIGIDO_SELADO_HS,
                this.enums.saudeBucalDenteProblemaCondicao.PROTESE_PARCIAL_REMOVIVEL,
                this.enums.saudeBucalDenteProblemaCondicao.PROTESE_TEMPORARIA,
                this.enums.saudeBucalDenteProblemaCondicao.INCLUSO_I,
            ]

            const parte2 = [
                this.enums.saudeBucalDenteProblemaCondicao.PROTESE_CORONARIA_UNITARIA,
                this.enums.saudeBucalDenteProblemaCondicao.COROA_CO,
                this.enums.saudeBucalDenteProblemaCondicao.IMPLANTE,
                this.enums.saudeBucalDenteProblemaCondicao.PILAR_P,
                this.enums.saudeBucalDenteProblemaCondicao.NUCLEO_PINO,
            ]

            const parte3 = [
                this.enums.saudeBucalDenteProblemaCondicao.RESTO_RADICULAR_RR,
                this.enums.saudeBucalDenteProblemaCondicao.RETRACAO_GENGIVAL_RG,
                this.enums.saudeBucalDenteProblemaCondicao.CALCULO_DENTAL_CD,
                this.enums.saudeBucalDenteProblemaCondicao.EXTRACAO_INDICADA_EI,
                this.enums.saudeBucalDenteProblemaCondicao.SELANTE_INDICADO_SI,
                this.enums.saudeBucalDenteProblemaCondicao.FRATURA_FR,
                this.enums.saudeBucalDenteProblemaCondicao.MANCHA_BRANCA_ATIVA_M,
                this.enums.saudeBucalDenteProblemaCondicao.CARIADO_C,
                this.enums.saudeBucalDenteProblemaCondicao.RESTAURADO_R,
                this.enums.saudeBucalDenteProblemaCondicao.CARIE_DA_RAIZ,
                this.enums.saudeBucalDenteProblemaCondicao.RESTAURADO_COM_CARIE_RC,
                this.enums.saudeBucalDenteProblemaCondicao.RAIZ_RESTAURADA,
                this.enums.saudeBucalDenteProblemaCondicao.NECESSITA_DE_TRATAMENTO_ENDODONTICO,
                this.enums.saudeBucalDenteProblemaCondicao.POSSUI_LESAO_DE_FURCA,
                this.enums.saudeBucalDenteProblemaCondicao.TRATAMENTO_ENDODONTICO_REALIZADO,
                this.enums.saudeBucalDenteProblemaCondicao.LESAO_DE_FURCA_TRATADA,
                this.enums.saudeBucalDenteProblemaCondicao.MANTENEDOR_DE_ESPACO_ME,
            ]

            const hasParte1Selected = this.model.problemasCondicoes.some(problemaCondicao => parte1.includes(problemaCondicao))
            const hasParte2Selected = this.model.problemasCondicoes.some(problemaCondicao => parte2.includes(problemaCondicao))
            const hasParte3Selected = this.model.problemasCondicoes.some(problemaCondicao => parte3.includes(problemaCondicao))

            if (hasParte1Selected && ((!this.model.problemasCondicoes.includes(id) && parte1.includes(id)) || parte2.includes(id) || parte3.includes(id))) {
                props.disabled = true
            } else if (hasParte2Selected && (parte1.includes(id) || parte3.includes(id))) {
                props.disabled = true
            } else if (hasParte3Selected && (parte1.includes(id) || parte2.includes(id))) {
                props.disabled = true
            }

            return props
        },
        getProblemasCondicoes() {
            return this.data.form.saudeBucal.odontograma.dentes.dente.problemasCondicoes.find(problemaCondicao => problemaCondicao.dentes.includes(this.model.numero)).itens
        },
        getProblemasCondicoesParte1() {
            return [
                this.enums.saudeBucalDenteProblemaCondicao.AUSENTE_A,
                this.enums.saudeBucalDenteProblemaCondicao.EXTRAIDO_E,
                this.enums.saudeBucalDenteProblemaCondicao.HIGIDO_H,
                this.enums.saudeBucalDenteProblemaCondicao.HIGIDO_SELADO_HS,
                this.enums.saudeBucalDenteProblemaCondicao.PROTESE_PARCIAL_REMOVIVEL,
                this.enums.saudeBucalDenteProblemaCondicao.PROTESE_TEMPORARIA,
                this.enums.saudeBucalDenteProblemaCondicao.INCLUSO_I,
            ]
        },
        getProblemasCondicoesParte2() {
            return [
                this.enums.saudeBucalDenteProblemaCondicao.PROTESE_CORONARIA_UNITARIA,
                this.enums.saudeBucalDenteProblemaCondicao.COROA_CO,
                this.enums.saudeBucalDenteProblemaCondicao.IMPLANTE,
                this.enums.saudeBucalDenteProblemaCondicao.PILAR_P,
                this.enums.saudeBucalDenteProblemaCondicao.NUCLEO_PINO,
                this.enums.saudeBucalDenteProblemaCondicao.RESTO_RADICULAR_RR,
                this.enums.saudeBucalDenteProblemaCondicao.RETRACAO_GENGIVAL_RG,
                this.enums.saudeBucalDenteProblemaCondicao.CALCULO_DENTAL_CD,
                this.enums.saudeBucalDenteProblemaCondicao.EXTRACAO_INDICADA_EI,
                this.enums.saudeBucalDenteProblemaCondicao.SELANTE_INDICADO_SI,
                this.enums.saudeBucalDenteProblemaCondicao.FRATURA_FR,
                this.enums.saudeBucalDenteProblemaCondicao.MANCHA_BRANCA_ATIVA_M,
                this.enums.saudeBucalDenteProblemaCondicao.CARIADO_C,
                this.enums.saudeBucalDenteProblemaCondicao.RESTAURADO_R,
                this.enums.saudeBucalDenteProblemaCondicao.CARIE_DA_RAIZ,
                this.enums.saudeBucalDenteProblemaCondicao.RESTAURADO_COM_CARIE_RC,
                this.enums.saudeBucalDenteProblemaCondicao.RAIZ_RESTAURADA,
                this.enums.saudeBucalDenteProblemaCondicao.NECESSITA_DE_TRATAMENTO_ENDODONTICO,
                this.enums.saudeBucalDenteProblemaCondicao.POSSUI_LESAO_DE_FURCA,
                this.enums.saudeBucalDenteProblemaCondicao.TRATAMENTO_ENDODONTICO_REALIZADO,
                this.enums.saudeBucalDenteProblemaCondicao.LESAO_DE_FURCA_TRATADA,
                this.enums.saudeBucalDenteProblemaCondicao.MANTENEDOR_DE_ESPACO_ME,
            ]
        },
        getProblemasCondicoesToDisable() {
            return [
                this.enums.saudeBucalDenteProblemaCondicao.AUSENTE_A,
                this.enums.saudeBucalDenteProblemaCondicao.EXTRAIDO_E,
                this.enums.saudeBucalDenteProblemaCondicao.HIGIDO_H,
                this.enums.saudeBucalDenteProblemaCondicao.PROTESE_PARCIAL_REMOVIVEL,
                this.enums.saudeBucalDenteProblemaCondicao.PROTESE_TEMPORARIA,
                this.enums.saudeBucalDenteProblemaCondicao.INCLUSO_I,
            ]
        },
        getProblemasCondicoesByDenteNumero(value) {
            return this.data.form.saudeBucal.odontograma.dentes.dente.problemasCondicoes.find(problemaCondicao => problemaCondicao.dentes.includes(value)).itens
        },
        getArcadas() {
            return this.data.model.saudeBucal.odontograma.arcadas
        },
        getDentes() {
            let dentes = []

            if (this.data.model.saudeBucal.odontograma.mostrarDentesDeciduos) {
                dentes = dentes.concat(this.getDentesSuperioresDeciduos())
                dentes = dentes.concat(this.getDentesInferioresDeciduos())
            }

            dentes = dentes.concat(this.getDentesSuperioresPermanentes())
            dentes = dentes.concat(this.getDentesInferioresPermanentes())

            dentes = dentes.filter(dente => dente.id !== this.model.id)
                .sort((a, b) => {
                    return a.numero - b.numero
                })

            return dentes
        },
        getDentesInferioresPermanentes() {
            return this.getArcadas().inferior.dentes.permanentes.map(dente => Object.assign(dente, {nome: `Dente ${dente.numero}`}))
        },
        getDentesInferioresDeciduos() {
            return this.getArcadas().inferior.dentes.deciduos.map(dente => Object.assign(dente, {nome: `Dente ${dente.numero}`}))
        },
        getDentesSuperioresDeciduos() {
            return this.getArcadas().superior.dentes.deciduos.map(dente => Object.assign(dente, {nome: `Dente ${dente.numero}`}))
        },
        getDentesSuperioresPermanentes() {
            return this.getArcadas().superior.dentes.permanentes.map(dente => Object.assign(dente, {nome: `Dente ${dente.numero}`}))
        },
    },
    mixins: [object],
    props: {
        data: {required: true, type: Object},
    },
    watch: {
        'model.problemasCondicoes'(value) {
            if (value.length === 0) {
                this.model.replicarProblemasCondicoesOutrosDentes = []
            }
        },
        'model.procedimentos'(value) {
            if (value.length === 0) {
                this.model.replicarProcedimentosOutrosDentes = []
            }
        },
    },
}
</script>